export const studentParentFields = [
    {
        fieldName: "role", type: "radio", customLabelName: "Are you a", required: true,
        options: [
            { label: "Student", value: "student" },
            { label: "Parent", value: "parent" },
        ]
    },
    { fieldName: "studentName", customLabelName: "Student Name", type: "text", placeholder: "Enter your Name", required: true },
    { fieldName: "parentName", customLabelName: "Parent Name", type: "text", placeholder: "Enter your Parent Name", required: true },
    { fieldName: "department", customLabelName: "Department", type: "text", placeholder: "Enter your Department", required: true },
    {
        fieldName: "year", type: "radio", customLabelName: "Year", required: true,
        options: [
            { label: "1 Year", value: "firstYear" },
            { label: "2 Year", value: "secondYear" },
            { label: "3 Year", value: "thirdYear" },
        ]
    },
    { fieldName: "academicPeriod", customLabelName: "Academic Period", type: "text", placeholder: "Enter Your Academic Period", required: true },
    { fieldName: "residentialAddress", customLabelName: "Residential Address", type: "text", placeholder: "Enter Your Residential Address", required: true },
    { fieldName: "contactNumberStudent", customLabelName: "Contact Number - Student", type: "text", placeholder: "Enter Your Contact Number", required: true, keyFilter:"int",maxLength:10 },
    { fieldName: "contactNumberParent", customLabelName: "Contact Number - Parent", type: "text", placeholder: "Enter Your Contact Number", required: true, keyFilter:"int",maxLength:10 },
    { fieldName: "email", type: "email", customLabelName: "Mail ID", placeholder: "Enter Mail ID", required: true },
    { fieldName: "universityRegNumber", customLabelName: "University Registration Number", type: "text", placeholder: "Enter University Registration Number", required: true },
    { fieldName: "idProof", type: "file", customLabelName: "Attach any ID Proof", required: true },
    { fieldName: "grievance", type: "text", customLabelName: "Your Grievances", placeholder: "Enter your Grievances", required: true },
    { fieldName: "grievanceProof", type: "file", customLabelName: "Attachment if any Proof regarding Grievances", required: true },
];